import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import LinearProgress from '@mui/material/LinearProgress';
import Modal from '@mui/material/Modal';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import Chip from '@mui/material/Chip';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import NorowsData from '../../../pages/General/NorowsData';
import Notification from '../../../pages/General/Notification';

import { fetchSubusersData,storeSubusersData,destorySubusersData,updateSubusersData,resetSubusersState } from './subusersSlice';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper'
};
const deleteModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};
const SubUserPage = () => {
    
    const dispatch = useDispatch();
    const subusers = useSelector(state => state.subusers);
    const profile = useSelector(state => state.auth.profile);
    const [modalVisible, setModalVisible] = useState(false);
    const [deleteid, setDeleteId] = React.useState("");
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const [editModalopen, setEditModalopen] = React.useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [userStatus, setUserStatus] = useState("");
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 10,
        page: 0,
      });
    const initialValues = {
        name: '',
        email: '',
        role:'sub-user',
        source:'LABELGEN',
        status:"ACTIVE",
        stores:[]
    }
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const onModalClose = () => {
        setModalVisible(false)
        setValues(initialValues)
        setErrors({})
    }
    const validator = (fieldValues) => {
        let temp = { ...errors }
        if ('name' in fieldValues)
            temp.name = fieldValues.name ? "" : "This field is required."
        if ('email' in fieldValues)
            temp.email = fieldValues.email ? "" : "This field is required."
        if ('role' in fieldValues)
            temp.role = fieldValues.role ? "" : "This field is required."

        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x == "")
    }
    const onInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
        validator({ [name]: value })
    }
    const handleSubmit = e => {
        e.preventDefault()
        const isValid = validator(values)
        if (isValid) {
            dispatch(storeSubusersData(profile && profile.id,values))
            setModalVisible(false)
        }
    }
    
    const handleClick = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };
    const deleteModalClose = () => {
        setDeleteModalopen(false);
    };
    const deleteuser = (id) => {
        dispatch(destorySubusersData(profile && profile.id,id))
        setDeleteModalopen(false);
        onModalClose()
    }

    const onEditModalClose = () => {
        setEditModalopen(false)
        setSelectedItem({})
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        if(e.target.value === "ACTIVE"){
            setUserStatus("ACTIVE")
        }else{
            setUserStatus("DELETED")
        }
    };
    const edithandleSubmit = e => {
       let finalData={
            "id":selectedItem && selectedItem.id,
            "name":selectedItem && selectedItem.name,
            "email":selectedItem && selectedItem.email,
            "status":userStatus
        }
        dispatch(updateSubusersData(profile && profile.id,finalData))
        setEditModalopen(false)
    }
    useEffect(() => {
        if (selectedItem) {
            setUserStatus(selectedItem && selectedItem.status)
        }

    }, [selectedItem]);
    const columns = [
        {
          field: 'name',
          headerName: 'Name',
          flex:1,
        },
        {
            field: 'email',
            headerName: 'Email',
            flex:1,
          },
          {
            field: 'status',
            headerName: 'Status',
            flex:1,
            renderCell: (params) => {
                if(params && params.row && params.row.status  && params.row.status==='ACTIVE' ){
                    return <Chip label={"ACTIVE"} color="success"  style={{ width:'165px',height:'28px',fontSize:'12px' }}/>
                }else{
                    return <Chip label={"INACTIVE"} color="primary"  style={{ width:'165px',height:'28px',fontSize:'12px' }}/>
                }
            }
          },
          {
            field: 'last_login',
            headerName: 'Last Login on',
            flex:1,
          },
        {
          field: 'action',
          headerName: 'Action',
          flex:1,
          renderCell: (params) => {
            return <div>
                 <span style={{ marginRight: '10px' }}>
                    <Tooltip title="Edit" placement="left-start">
                        <IconButton
                            onClick={() => {
                                setSelectedItem(params.row);
                                setEditModalopen(true)
                            }}
                        >
                            <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} />
                        </IconButton>
                    </Tooltip>
                </span>
                <span>
                    <Tooltip title="Delete" placement="left-start">
                        <IconButton 
                            onClick={(e) => {
                            handleClick(params.row.id)
                            }}
                        >
                            <DeleteOutlineOutlinedIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }}/>
                        </IconButton>
                    </Tooltip>
                </span>
            </div>
        }
        },
      ];
    useEffect(() => {
        dispatch(fetchSubusersData())
    }, [dispatch])

    return (
        <>
         {(subusers && subusers.notification && subusers.notification.messageContent!='') &&
            <Notification
                is_open={subusers.notification.show}
                messageType={subusers.notification.messageType}
                messages={subusers.notification.messageContent}
                handleClose={() => dispatch(resetSubusersState())}
            />}
        <Modal
            open={modalVisible}
            onClose={onModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Card sx={{ minWidth: 600 }} className="sc--cardhead--details">
                    <CardHeader title='Add User' />
                    <Divider />
                    <CardContent>
                        <div className="sc--form--center" style={{ margin: '20px 0' }}>
                            <TextField
                                label="Name"
                                name="name"
                                defaultValue={values && values.name}
                                onChange={onInputChange}
                                error={errors.name}
                                helperText={errors.name}
                                style={{ width: "100%", margin: '8px' }}
                                variant="standard"
                            />
                        </div>
                        <div className="sc--form--center" style={{ margin: '20px 0' }}>
                            <TextField
                                label="email"
                                type='email'
                                name="email"
                                defaultValue={values && values.email}
                                onChange={onInputChange}
                                error={errors.email}
                                helperText={errors.email}
                                variant="standard" style={{ width: "100%", margin: '8px' }}
                            />
                        </div>
                        <div className="sc--form--center" style={{ margin: '20px 0' }}>
                            <FormControl
                                variant="standard"
                                className="help-text-error"
                                style={{ width: "100%", margin: '8px' }}
                            >
                                <InputLabel id="demo-simple-select-standard-label">Role</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-error"
                                    name="role"
                                    defaultValue={values && values.role}
                                    error={errors.role}
                                    onChange={onInputChange}
                                    label="Length Unit"
                                >
                                    <MenuItem value={"sub-user"}>USER</MenuItem>

                                </Select>
                                <FormHelperText>{errors.role}</FormHelperText>
                            </FormControl>
                        </div>
                        <div className="sc--form--center" style={{ margin: '30px 0' }}>
                            <Button variant="outlined" onClick={handleSubmit}>Submit</Button>
                        </div>
                    </CardContent>
                </Card>
            </Box>
        </Modal >
        <Modal
                open={editModalopen}
                onClose={onEditModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Card sx={{ minWidth: 400 }} className="sc--cardhead--details">
                        <CardHeader title='Update Subuser Status' />
                        <Divider />
                        <CardContent>
                        <div className="sc--form--center" style={{ margin: '20px 0' }}>
                            <TextField
                                label="Email"
                                name="email"
                                defaultValue={selectedItem && selectedItem.email}
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                  }}
                                style={{ width: "100%", margin: '8px' }}
                                variant="standard"
                            />
                        </div>
                        <div className="sc--form--center" style={{justifyContent:'unset'}}>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    defaultValue={userStatus}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="ACTIVE"  control={<Radio size="small" />} label={<Typography style={{ fontSize: '12px' }}>ACTIVE</Typography>} />
                                    <FormControlLabel value="DELETED" control={<Radio size="small" />} label={<Typography style={{ fontSize: '12px' }}>INACTIVE</Typography>} />
                                </RadioGroup>
                            </div>
                            <div className="sc--form--center" style={{ margin: '30px 0' }}>
                                <Button variant="outlined" onClick={edithandleSubmit}>Submit</Button>
                            </div>
                        </CardContent>
                    </Card>
                </Box>
            </Modal >
        <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={deleteModalStyle}>
                    <Typography sx={{ p: 2 }}>Are you sure want to delete this subuser?<br />
                        <div style={{ display: 'flex', justifyContent: 'center',marginTop:'10px' }}>
                            <span style={{ margin: '0 10px' }}>
                                <Button
                                    variant="contained"
                                    style={{ margin: "10px 0" }}
                                    onClick={(event) => {
                                        deleteuser(deleteid)
                                    }}
                                >
                                    Yes
                                </Button>
                            </span>
                            <span>
                                <Button
                                    variant="outlined"
                                    style={{ margin: "10px 0" }}
                                    onClick={deleteModalClose}
                                >
                                    No
                                 </Button>
                            </span>
                        </div>
                    </Typography>
                </Box>
            </Modal>
        <Card sx={{ minWidth: '100%',boxShadow:'unset' }} className="sc--cardhead--details">
        <CardHeader title='Subusers' className="sc--cardhead--details" action={
            <div>
                <Button variant="contained" onClick={() => { 
                     setModalVisible(true)
                     setValues(initialValues)
                 }}>Add Subuser</Button>
            </div>
        }/>
        <Divider />
        <CardContent>
            <Box >
                <DataGrid
                    getRowId={(row) => row.id}
                    disableRowSelectionOnClick={true}
                    rows={subusers && subusers.data}
                    columns={columns}
                    autoHeight={true}
                    slots={{
                        loadingOverlay: LinearProgress,
                        NorowsData,
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    loading={subusers && subusers.loading}
                />
            </Box>
        </CardContent>
    </Card>
    </>
    )
    
}


export default SubUserPage;
